import React from 'react'
import './address.css'
import Images from '../../data/Images'

const Address = () => {
  return (
    <div className='a-address'>
        <div className="a-main">
        <img src={Images.Address} alt="Address" />
        <div data-aos="fade-up" className='address'>610 Anand Nagar A, Tripuri, <br/> Patiala, Punjab, India.</div>
        </div>

        <div className="address-line"></div>

        <div className="a-main">
        <img src={Images.Email} alt="Email" />
        <div data-aos="fade-up" className="email">dhruvasth@gmail.com</div>
        </div>

        <div className="address-line"></div>

        <div className="a-main">
        <img src={Images.Phone} alt="Phone" />
        <div data-aos="fade-up" className="phone">+91 9781-268-233</div>
        </div>
    </div>
  )
}

export default Address